<template>
  <div class="appeal-item">
    <h4 class="appeal-item__title">№: {{ appeal.appealNumber }}</h4>

    <div
      class="appeal-item__body"
      v-if="appeal.textHistory && appeal.textHistory.length > 0"
    >
      <!-- <div class="appeal-item__body-title">Müraciət Tarixçəsi</div> -->
      <div
        v-for="(item, idx) in appeal.textHistory"
        :key="idx"
        class="appeal-item__text-history-item"
      >
        <div class="appeal-item__text-history-item--text">
          Müraciətin mətni: {{ " " + (item.text || "(Müraciət mətni daxil edilməyib)") }}
        </div>

        <div class="appeal-item__text-history-item--date">
          Tarix: {{ item.dateStr }}
        </div>
      </div>
    </div>
    <div v-else>Müraciət mətni daxil edilməyib</div>

    <div class="appeal-item__footer">
      <!-- <button
        v-if="appeal.files.length > 0"
        class="appeal-item__view-files-btn"
        @click="handleSelectFilesToDisplay"
      >
        Fayllar
      </button> -->

      <!-- <div class="appeal-item__date">{{ appeal.dateStr }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appeal: Object,
  },
  computed: {
    // getDateTime() {
    //   const date = this.appeal.dateStr.split('T')[0];
    //   const time = this.appeal.dateStr.split('T')[1];
    //   return `${date} ${time}`
    // }
    // getappealColor() {
    //   switch (this.appeal.score) {
    //     case 1:
    //       return "#FF5252";
    //     case 2:
    //       return "#FB8C00";
    //     case 3:
    //       return "#4CAF50";
    //     default:
    //       return "#2196F3";
    //   }
    // },
    // getStartAgainStr() {
    //   if (this.assestment.startAgain) return "Təsdiq";
    //   else return "İmtina";
    // },
    // getDateStr() {
    //   return this.assestment.opDateStr;
    // }
  },
  methods: {
    // handleSelectFilesToDisplay() {
    //   this.$emit("selected", this.assestment.files);
    // }
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
